<template>
  <div class="user-management-wrap">
    <modal @close-modal="closeModals" v-if="showModal">
      <ChangePasswordModal
        v-if="showModal && showChangePassword"
        :userId="userId"
        :fullName="fullName"
        @close-modal="closeModals"
        @success="updateSuccessMessage"
      ></ChangePasswordModal>
      <EditProfileModal
        @close-modal="closeModals"
        @closeAndRefresh="closeModalsAndRefreshUsers"
        :userId="userId"
        :originalName="name"
        :originalLastname="lastname"
        :originalEmail="email"
        v-if="showModal && showEditProfile"
      />
      <ConfirmationModal
        @close-modal="closeModals"
        @closeAndRefresh="closeModalsAndRefreshUsers"
        :userId="userId"
        v-if="showModal && showConfirmationModal"
      />
    </modal>
    <div class="input-wrap">
      <div class="input-img-wrap">
        <input
          class="search"
          type="text"
          placeholder="Search..."
          v-model="search"
        />
        <img :src="$images.search" alt="search" />
      </div>
    </div>
    <div class="table-wrap">
      <div class="table-header">
        <div>{{ $t("register.name") }}</div>
        <div>{{ $t("register.lastName") }}</div>
        <div>{{ $t("register.email") }}</div>
        <div></div>
      </div>
      <p class="no-data" v-if="isUsersEmpty">
        {{ $t("adminUserManagement.noUsersFound") }}
      </p>
      <div class="table-rows" name="slide-in" appear v-if="users.length">
        <div class="table-row" v-for="(user, index) in users" :key="index">
          <div class>{{ user.usr_firstname }}</div>
          <div class>{{ user.usr_lastname }}</div>
          <div class>{{ user.usr_email }}</div>
          <div class="button-wrap">
            <button
              class="change-button"
              @click="
                setInfoAndOpenModal(
                  user.usr_id,
                  user.usr_firstname,
                  user.usr_lastname
                )
              "
            >
              {{ $t("button.changePassword") }}
            </button>
            <button
              class="change-button"
              @click="
                openEditProfileModal(
                  user.usr_id,
                  user.usr_firstname,
                  user.usr_lastname,
                  user.usr_email
                )
              "
            >
              {{ $t("button.editProfile") }}
            </button>
            <span class="material-icons delete-btn" @click="openConfirmationModal(user.usr_id)">delete</span>
            <!-- <button
              class="change-button"
              @click="openConfirmationModal(user.usr_id)"
            >
              {{ $t("button.deleteProfile") }}
            </button> -->
          </div>
        </div>
      </div>
      <pagination
        :pageCount="pageCount"
        :pageNumber="pageNumber"
        @page-change="updatePageAndGetUsers"
      ></pagination>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import Pagination from "../../components/admin/Pagination";
import AdminMixin from "@/views/admin-pages/adminMixin.js";
import ChangePasswordModal from "../../components/admin/user-management/ChangePasswordModal";
import EditProfileModal from "@/components/admin/user-management/EditProfileModal";
import ConfirmationModal from "@/components/admin/user-management/ConfirmationModal";
export default {
  mixins: [AdminMixin],
  components: {
    ChangePasswordModal,
    Pagination,
    EditProfileModal,
    ConfirmationModal,
  },
  data() {
    return {
      users: [],
      isUsersEmpty: false,
      userCount: null,
      showModal: false,
      userId: null,
      limit: 15,
      pageNumber: 1,
      pageCount: 0,
      fullName: "",
      search: "",
      showChangePassword: false,
      showEditProfile: false,
      showConfirmationModal: false,
      name: "",
      lastname: "",
      email: "",
    };
  },
  methods: {
    async getUsers() {
      try {
        this.startLoading();
        const res = await api.getUsers({
          search: this.search,
          limit: this.limit,
          offset: (this.pageNumber - 1) * this.limit,
        });
        if (res.data.result !== null) {
          this.users = res.data.result;
          this.isUsersEmpty = false;
        } else {
          this.isUsersEmpty = true;
        }
        this.stopLoading();
      } catch (error) {
        this.handleError(error);
      }
    },
    async getUserCountAndSetPageCount() {
      try {
        this.startLoading();
        const res = await api.getUserCount({
          search: this.search,
        });
        this.userCount = res.data.num;
        this.pageCount = Math.ceil(this.userCount / this.limit);
        this.stopLoading();
      } catch (error) {
        this.handleError(error);
      }
    },
    setInfoAndOpenModal(id, name, lastname) {
      this.userId = id;
      this.fullName = `${name} ${lastname}`;
      this.showModal = true;
      this.showChangePassword = true;
    },
    openEditProfileModal(id, name, lastname, email) {
      this.userId = id;
      this.name = name;
      // console.log(name);
      this.lastname = lastname;
      this.email = email;
      this.showModal = true;
      this.showEditProfile = true;
    },
    openConfirmationModal(id) {
      this.userId = id;
      this.showModal = true;
      this.showConfirmationModal = true;
    },
    closeModals() {
      this.showModal = false;
      this.showChangePassword = false;
      this.showEditProfile = false;
      this.showConfirmationModal = false;
    },
    updateSuccessMessage(msg) {
      this.$emit("success", msg);
    },
    updatePageAndGetUsers(page) {
      this.pageNumber = page;
      this.getUsers();
    },
    setSearchedFalse() {
      this.searched = false;
    },
    setPageCount() {
      this.pageCount = Math.ceil(this.userCount / this.limit);
    },
    closeModalsAndRefreshUsers() {
      this.getUserCountAndSetPageCount();
      this.getUsers();
      this.closeModals();
    },
  },
  watch: {
    search: {
      handler() {
        if (this.searchTimeout) {
          clearInterval(this.searchTimeout);
          this.searchTimeout = null;
        }
        this.searchTimeout = setTimeout(() => {
          this.pageNumber = 1;
          this.getUserCountAndSetPageCount();
          this.getUsers();
          this.searchTimeout = null;
        }, 500);
      },
    },
  },
  created() {
    this.getUserCountAndSetPageCount();
    this.getUsers();
  },
};
</script>

<style scoped lang='scss'>
* {
  box-sizing: border-box;
}
.user-management-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #e5e5e5;
}
.table-wrap {
  display: flex;
  flex-direction: column;
  width: 90%;
  border-radius: 20px;
  overflow: hidden;
  min-height: 700px;
}
.table-header {
  height: 5%;
}
.table-rows {
  flex-grow: 1;
  background-color: white;
}
.table-header,
.table-row {
  display: flex;
  width: 100%;
  background-color: #343434;
  color: white;
}
.table-header div,
.table-row div {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: calc(100% / 6);
  word-break: break-word;
}
.table-row {
  background-color: white;
  padding: 5px 0;
  color: black;
  height: 6.67%;
  border-bottom: 1px solid #e5e5e5;
}
.change-button {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  border: none;
  padding: 5px 10px;
  box-shadow: 0px 0px 250px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
  font-size: 15px;
  font-weight: 600;
  background: var(--button-color-blue);
  color: white;
  margin: 0 1em;
}
.change-button:active,
.change-button:focus {
  border: none;
  outline: none;
}
.table-row {
  .button-wrap {
    display: flex;
    // justify-content: center;
    flex-grow: 1;
  }
}
.input-wrap {
  width: 70%;
}
.input-img-wrap {
  position: relative;
  width: 30%;
  margin: 2% 0;
}
.input-wrap img {
  position: absolute;
  font-size: 20px;
  right: 9px;
  top: 9px;
}
img {
  width: 15px;
}
.no-data {
  background: white;
  height: 100%;
  width: 100%;
  text-align: center;
  padding: 5% 0;
  margin: 0;
}

.delete-btn {
  opacity: .7;
  cursor: pointer;
}

@media (max-width: 700px) {
  .table-rows {
    height: 83%;
    background-color: white;
  }
  .pagination {
    height: 10%;
  }
}

/* TRANSITION */
.slide-in-enter {
  transform: translateX(-30px);
  opacity: 0;
}
.slide-in-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.slide-in-enter-active,
.slide-in-leave-active {
  transition: all 0.2s ease;
}
</style>